/*********
 Desktop Dropdown Menu
 **********/
const headerButtons = document.querySelectorAll('.headerNavButton');

headerButtons.forEach(button => {
    // on click update the active on buttons and the aria-expanded attribute
    button.addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active');
            this.setAttribute('aria-expanded', 'false');
            return;
        }
        closeDesktopMenu();
        this.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
    })
})

// closing menu when mouse leaves the menu area
document.querySelectorAll('.headerNavDropInner').forEach(drop => {
    drop.addEventListener('mouseleave', () => {
        closeDesktopMenu()
    })
})

// closing menu on escape and focus on main content
document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        closeDesktopMenu();
        document.querySelector('.mainContentFocus')?.focus();
    }
});

function closeDesktopMenu() {
    headerButtons.forEach(el => {
        el.classList.remove('active');
        el.setAttribute('aria-expanded', 'false');
    })
}

/**************
 Mobile Nav
 ***************/

const slider = document.querySelector("#slider");

// slider dialog close
slider.addEventListener('close', () => {
    document.querySelector("body").classList.remove("noScroll");
    document.querySelector('#headerMenu').setAttribute('aria-expanded', 'false');
})

// slider dialog close
slider.addEventListener('click', function (e) {
    if (e.target === this) slider.close();
})

// open nav event listener
document.querySelector('#headerMenu').addEventListener("click", function () {
    slider.showModal();
    slider.focus();
    document.querySelector("body").classList.add("noScroll");
    this.setAttribute('aria-expanded', 'true');
    // set padding on top of slider, pushes menu under header
    const headerBottom = document.querySelector('#header').getBoundingClientRect().bottom;
    slider.style.paddingTop = `${headerBottom}px`
});

/**************
 Mobile Nav Dropdowns
 ***************/

document.querySelectorAll('.sliderContentItemButton').forEach(button => {
    button.addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active');
            this.setAttribute('aria-expanded', 'false');
            return;
        }
        document.querySelectorAll('.sliderContentItemButton').forEach(el => {
            el.classList.remove('active');
            el.setAttribute('aria-expanded', 'false');
        })
        this.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
    })
});